import React from "react";

class CryptoWidget extends React.PureComponent {
  constructor(
    props,
    symbol,
    trendLineColor,
    underLineColor,
    underLineBottomColor
  ) {
    super(props);
    this.ref = React.createRef();
  }
  componentDidMount() {
    const script = document.createElement("script");
    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js";
    script.async = true;
    script.innerHTML = JSON.stringify({
      symbol: this.props.symbol,
      width: "200",
      height: "150",
      locale: "en",
      dateRange: "1D",
      colorTheme: "dark",
      trendLineColor: this.props.trendLineColor,
      underLineColor: this.props.underLineColor,
      underLineBottomColor: this.props.underLineBottomColor,
      isTransparent: true,
      autosize: true,
      largeChartUrl: "",
    });
    /* JSON-ENCODED SETTINGS STRING FROM EMBED CODE */
    this.ref.current.appendChild(script);
  }

  render() {
    return (
      <div className="btc-widget">
        <div className="title-text"></div>
        <div className="tradingview-widget-container box-shadow" ref={this.ref}>
          <div className="tradingview-widget-container__widget"></div>
        </div>
      </div>
    );
  }
}

export default CryptoWidget;
